<template>
  <div class="message-poke">
    <p v-for="(item, index) in props.message.patMsgs" :key="index">
      {{ `${item.template}` }}
    </p>
  </div>
</template>

<script setup>
const props = defineProps({
  dataItem: {
    type: Object,
    default: () => ({
      content: ''
    })
  },
  message: {
    type: Object,
    default: () => ({
      patMsgs: []
    })
  }
})
</script>

<style lang="scss" scoped>
.message-poke {
  padding: 0 48px;
  font-size: 12px;
  line-height: 16px;
  color: #969799;
  text-align: center;

  p {
    &:not(&:first-child) {
      margin-top: 16px;
    }
  }
}
</style>
